import { color } from 'theme'
import { Icon } from 'components/ui'

import { StyleLoader } from './Style'

type Props = {
  size?: number
  color?: string
}

const colorDefault = color.default

function Loader({ size = 2, color = colorDefault }: Props) {
  return (
    <StyleLoader width={size} height={size} color={color}>
      <Icon name='loader' size='fill' />
    </StyleLoader>
  )
}

export { Loader }
